import { render } from "./testCrosView.vue?vue&type=template&id=6a8c414b&scoped=true"
import script from "./testCrosView.vue?vue&type=script&lang=js"
export * from "./testCrosView.vue?vue&type=script&lang=js"

import "./testCrosView.vue?vue&type=style&index=0&id=6a8c414b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8c414b"]])

export default __exports__